import { getApiActionTypes } from '../../shared/store/storeHelpers';

export const fetchWorkpaperInstanceDataTypes = getApiActionTypes('WORKPAPER_INSTANCE/FETCH_DATA');
export const updateWorkpaperInstanceTypes = getApiActionTypes('WORKPAPER_INSTANCE/UPDATE');
export const fetchDatasetDefinitionMetaDataTypes = getApiActionTypes(
  'WORKPAPER_INSTANCE/DATASET_DEFINITION_META_DATA',
);
